// extracted by mini-css-extract-plugin
export default {"wrapper":"ModifiersFooter-module__wrapper___23WuS","buttonWrapper":"ModifiersFooter-module__buttonWrapper___3iVz0"};